export const enum JornadaStatusEnum {
    FINALIZADA = 'FINALIZADA',
    INICIADA = 'INICIADA',
    NAO_INICIADA = 'NAO_INICIADA',
    EM_BREVE = 'EM_BREVE',
    UNKNOWN = '_'
}
